/*
 * Copyright (c) 2021, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { IDPs } from "../../data/interfaces";
import {
    IDPsAction, FETCH_IDP_REQUEST, FETCH_IDP_SUCCESS, FETCH_IDP_FAILURE
} from '../types/idps';

interface IDPReducerState {
    isLoading: boolean,
    idps: IDPs,
    error: string
}

const initialState: IDPReducerState = {
    isLoading: false,
    idps: { count: 0, list: [] },
    error: ''
}

const idpReducer = (state = initialState, action: IDPsAction) => {
    switch (action.type) {

        case FETCH_IDP_REQUEST:
            return {
                ...state,
                isLoading: true,
            }
        case FETCH_IDP_SUCCESS:
            return {
                ...state,
                isLoading: false,
                idps: action.payload
            }

        case FETCH_IDP_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload
            };
        default:
            return state
    }
}

export default idpReducer;
